import React, { useEffect, useState } from 'react';
import {
    Panel,
    IPanelStyles,
    PanelType,
} from '@fluentui/react';
import LoaderComponent from '../loader/loader.component';
import ErrorMessageComponent from '../error-message/error-message.component';
import ButtonWhiteComponent from '../button-white/button-white.component';
import ButtonBlueComponent from '../button-blue/button-blue.component';
import ButtonLinkComponent from '../button-link/button-link.component';
import Signature from "signature_pad";
import moment from 'moment';
import { Buffer } from 'buffer';

import useAuthStatus from '../../hooks/auth/AuthHook';
import ApiService from '../../services/api/api.service';

import ItemRegistroTiempo from '../../models/ItemRegistroTiempo';
import ItemDocumento from '../../models/ItemDocumento';
import ItemTarea from '../../models/ItemTarea';

const panelStyles : IPanelStyles = {
    root: {},
    overlay: {},
    hiddenPanel: {},
    main: {},
    commands: {
        marginTop: 0,
    },
    contentInner: {},
    scrollableContent: {},
    navigation: {
        backgroundColor: 'var(--color-primario)',
        padding: 10,
        alignItems: 'center',
    },
    header: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 5,
        paddingBottom: 5,
    },
    headerText: {
        color: '#ffffff',
    },
    content: {
        padding: 0,
    },
    footer: {},
    footerInner: {},
    subComponentStyles: {
        closeButton: {
            root: {
                color: '#ffffff',
                backgroundColor: 'transparent',
                padding: 0,
            },
            rootHovered: {
                backgroundColor: '#000000',
                color: '#ffffff',
                borderColor: '#000000',
            },
        },
    },
};

const getFileSize = (base64: string) : number => {
    const buffer : Buffer = Buffer.from(base64.substring(base64.indexOf(',') + 1));
    return (buffer.length / 1e+6);
};

interface IWorkPartFinishComponentProps {
    work: ItemTarea;
    onClose: () => void;
    onWorkPartFinished?: () => void;
    onOpenWorkPartFinishInfo: () => void;
    workPartFinishInfoOpen: boolean;
    unfinishedWorkPart?: ItemRegistroTiempo;
};

const WorkPartFinishComponent = (props: IWorkPartFinishComponentProps) => {
    const auth = useAuthStatus();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [signaturePad, setSignaturePad] = useState<Signature>();

    useEffect(() => {
        setTimeout(() => {
            startPad();
        }, 1000);
    }, []);

    const startPad = () : void => {
        const wrapper : HTMLElement | null = document.getElementById("signature-pad");
        if (wrapper) {
            const canvas : HTMLCanvasElement | null | undefined = wrapper.querySelector("canvas");
            if (canvas) {
                const context : CanvasRenderingContext2D | null = canvas.getContext("2d");
                if (context) {
                    context.scale(1, 1);
                    const tempSignaturePad : Signature = new Signature(canvas, {
                        backgroundColor: "#ffffff",
                    });
                    setSignaturePad(tempSignaturePad);
                }
            }
        }
    };

    const onClean = () : void => {
        if (signaturePad) {
            signaturePad.clear();
        }
    };

    const onFinishUnfinishedWorkPart = () : Promise<void> => {
        return new Promise((resolve, reject) => {
            if (auth.user) {
                if (props.unfinishedWorkPart) {
                    let unfinishedWorkPart : ItemRegistroTiempo = props.unfinishedWorkPart;
                    unfinishedWorkPart.Fin = moment().format("YYYY-MM-DD HH:mm:ss");
                    ApiService.Post<string>("OrdenesTrabajo", "SetRegistroTiempo", auth.user, {
                        "ItemRegistroTiempo": props.unfinishedWorkPart,
                    }).then(() => {
                        resolve()
                    }, (error: string) => {
                        reject(error);
                    });
                }
                else {
                    resolve();
                }
            }
            else {
                reject("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
            }
        });
    };

    const onSubmit = () : void => {
        if (auth.user) {
            if (signaturePad) {
                if (!signaturePad.isEmpty()) {
                    const signature : string = signaturePad.toDataURL("image/png");
                    if (signature) {
                        setLoading(true);
                        onFinishUnfinishedWorkPart().then(() => {
                            if (auth.user) {
                                let document : ItemDocumento = new ItemDocumento();
                                document.Clave = props.work.Id.toString();
                                document.CodigoCliente = auth.user.CodigoCliente;
                                document.Descargado = false;
                                document.Descripcion = "Firma";
                                document.EsFirma = true;
                                document.Extension = "png";
                                document.IdElemento = 1100;
                                document.Imagen = signature;
                                document.NombreArchivo = "Firma";
                                document.PosicionGPS = "";
                                document.Size = getFileSize(signature).toFixed(2);
                                document.fecDoc = moment().format("YYYY-MM-DD HH:mm:ss");
                                document.imgBase64 = signature;
                                ApiService.Post<string>("OrdenesTrabajo", "SetDocumentoAdjunto", auth.user, {
                                    "ItemDocumentoAdjunto": document,
                                }).then(() => {
                                    if (auth.user) {
                                        ApiService.Post<void>("OrdenesTrabajo", "SetTareaFinalizada", auth.user, {
                                            "Id": props.work.Id,
                                            "IdOrden": props.work.IdOrden,
                                            "FechaFinalizacion": moment().format("YYYY-MM-DD HH:mm:ss"),
                                            "FormularioDatos": props.work.FormularioDatos,
                                        }).then(() => {
                                            if (props.onWorkPartFinished) {
                                                props.onWorkPartFinished();
                                            }
                                            props.onClose();
                                            setLoading(false);
                                        }, (error: string) => {
                                            setError(error);
                                            setLoading(false);
                                        });
                                    }
                                    else {
                                        setError("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                                        setLoading(false);
                                    }
                                }, (error: string) => {
                                    setError(error);
                                    setLoading(false);
                                });
                            }
                            else {
                                setError("Ha ocurrido un error inesperado. Por favor, intente nuevamente.");
                                setLoading(false);
                            }
                        }, (error: string) => {
                            setError(error);
                            setLoading(false);
                        });
                    }
                    else {
                        setError("Complete la firma.");
                    }
                }
                else {
                    setError("Complete la firma.");
                }
            }
        }
    };

    return (
        <Panel
            isOpen={true}
            headerText="Firma"
            onDismiss={props.onClose}
            styles={panelStyles}
            type={PanelType.medium}
            isBlocking={!props.workPartFinishInfoOpen}>
            <div className="container-fluid p-0">
                <div className="row mx-0 mb-3">
                    <div className="col-12">
                        <ButtonLinkComponent
                            className='w-100'
                            text='¿Qué voy a firmar?'
                            icon='ChevronRightSmall'
                            onClick={props.onOpenWorkPartFinishInfo} />
                    </div>
                </div>
                <div className="row mx-0 mb-3">
                    <div className='col-12 d-flex text-center'>
                        <div 
                            id="signature-pad" 
                            className='text-center border border-1 border-dark rounded m-auto p-1'>
                            <canvas 
                                width={400}
                                height={400}></canvas>
                        </div>
                    </div>
                </div>
                <div className="row m-0">
                    <div className='col-6'>
                        <ButtonWhiteComponent
                            className='w-100'
                            text='BORRAR TODO'
                            onClick={onClean} />
                    </div>
                    <div className='col-6'>
                        <ButtonBlueComponent
                            className='w-100'
                            text='ACEPTAR'
                            onClick={onSubmit} />
                    </div>
                </div>
                <div className='row m-0'>
                    <div className='col-12'>
                        <ErrorMessageComponent message={error} />
                    </div>
                </div>
            </div>
            <LoaderComponent loading={loading} />
        </Panel>
    );
};

export default WorkPartFinishComponent;
